import Constant from '@/common/constant/Constant';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import Utils from '@/common/utils/utils';

export default function ContentEmailCheckboxDeliver({
    currentEmailTicket,
    currentTicketDeliverStatus,
    setCurrentTicketDeliverStatus,
    setIsEditedCurrentTicket,
    originTicket,
    isDisableEdit               
}) {


    let defaultDisable = true;
    let isProjectEmail = currentEmailTicket?.projectOrigin === currentEmailTicket?.affiliationProject;
    const isArchive = originTicket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;
    let isDisableCheckBox = isArchive || !Utils.isEmptyString(originTicket.deletedAt);

    if (!isProjectEmail || currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL) {
        return <></>
    }

    // When ticket is deliver , so do not display checkbox
    if(currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY && currentEmailTicket?.deliverInfo?.status) {
        return <></>
    }
    

    if (currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY && 
        isProjectEmail && 
        currentEmailTicket.deliverInfo && 
        !currentEmailTicket.deliverInfo.status
        
    ) {
        defaultDisable = false;
    }

    if (!isProjectEmail || currentEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL || defaultDisable) {
        return <></>
    }
    
    const onClickCheckbox = () => {
        if (isDisableCheckBox || isDisableEdit) return;
        setCurrentTicketDeliverStatus(!currentTicketDeliverStatus)
        setIsEditedCurrentTicket(true)
    }
    
    return (
        <div className='form-addTicket'>
            <FormControlLabel
                control={
                        <Checkbox 
                        checked={currentTicketDeliverStatus} 
                        onChange={onClickCheckbox}
                        disabled={defaultDisable || isDisableCheckBox || isDisableEdit}
                    />
                }
                label={'メール配信'} 
                className={`checkbox-item-of-tag-field`}
            />
        </div>
    );
}
